export const getSampleJSONContent = () => {
  const template = {
    data: {
      portfolioItems: [
        {
          name: "Stocks",
          targetAllocation: 50,
          items: [],
          subCategories: [
            {
              name: "US Tech",
              targetAllocation: 20,
              items: [
                 { "symbol": "AAPL", "targetAllocation": 10 }
              ]
            }
          ]
        },
        {
          name: "Cash",
          targetAllocation: 10,
          items: [
             { "symbol": "USD", "targetAllocation": 10 }
          ],
          subCategories: []
        },
        {
            name: "Diğer",
            targetAllocation: 0,
            items: [],
            subCategories: []
        }
      ]
    }
  };
  return JSON.stringify(template, null, 2);
};

export const parsePortfolioJSON = (jsonText) => {
  try {
    const json = JSON.parse(jsonText);
    
    let portfolioItems = [];
    
    // Farklı JSON yapılarını destekle (Dashboard export vs sade liste)
    if (json.data && Array.isArray(json.data.portfolioItems)) {
      portfolioItems = json.data.portfolioItems;
    } else if (json.portfolioItems && Array.isArray(json.portfolioItems)) {
        portfolioItems = json.portfolioItems;
    } else if (Array.isArray(json)) {
      portfolioItems = json;
    } else {
      throw new Error('Geçersiz JSON formatı. "portfolioItems" dizisi bulunamadı.');
    }

    return portfolioItems;
  } catch (e) {
      throw new Error('JSON parse hatası: ' + e.message);
  }
};

